'use client';

import React from 'react';
import Image from 'next/image';
import dynamic from 'next/dynamic';

// Splideコンポーネントを動的インポートでコード分割
const SplideCarousel = dynamic(() => import('./splide-carousel'), {
  ssr: false,
  loading: () => (
    <div className="w-full h-[200px] bg-gray-200 animate-pulse rounded flex items-center justify-center">
      <span className="text-gray-500">読み込み中...</span>
    </div>
  ),
});

type JobImageSlideProps = {
  imageUrls: string[];
  jobTitle?: string;
};

const JobImageSlide: React.FC<JobImageSlideProps> = ({
  imageUrls,
  jobTitle,
}) => {
  if (imageUrls.length === 0) return null;

  return (
    <>
      {imageUrls.length > 1 ? (
        <SplideCarousel imageUrls={imageUrls} jobTitle={jobTitle} />
      ) : (
        <Image
          src={imageUrls[0]}
          alt={jobTitle || '求人詳細の画像'}
          width={300}
          height={200}
          className="p-job-detail__image"
          priority
          sizes="(max-width: 768px) 100vw, 300px"
          unoptimized
        />
      )}
    </>
  );
};

export default JobImageSlide;
